export default __webpack_public_path__ + "static/media/AffiliateProgramIcon.082257bb.svg";